module.exports = __webpack_public_path__ + "cefdbbdfbd3f4ab78f37d28e76e55bd6.svg";